// import './main.css'
// import React, { useEffect, useState } from 'react'
// import { useContext } from 'react';
// import { AppContext } from '../../App';
// import { json, useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Side from '../side/Side';

// const MainPage = () => {
//     const {route ,setLoader}=useContext(AppContext)
//     const [user,setUser]=useState({})
//     const [child,setChild]=useState({})
//     const [left,setLeft]=useState({})
//     const [right,setRight]=useState({})
//     const [pass,setPass]=useState("")
//     const [passConfirm,setPassConfirm]=useState("")
//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         setLoader(true)
      
//         const formData = new FormData();
//         formData.append('bocket_password', pass);
//         formData.append('bocket_password_confirmation', passConfirm);
//         console.log(pass)
//         try {
//           const response = await fetch(`${route}/acc/setBucketPassword`, {
//             method: 'PUT',
//             headers:{
//                 'Content-Type': 'application/json',
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             },
//             body: JSON.stringify({
//                 bocket_password : pass , 
//                 bocket_password_confirmation : passConfirm
//             })
//           })
//           .then(res=>res.json())
//           console.log(response)
//           setLoader(false)
//           if(response.status === "success"){
//             toast.success(response.msg)
//           }
//           else if(response.status === "faild"){
//             toast.error(response.msg)
//           }
//          else if(response.errors.bocket_password){
//             toast.error(response.errors.bocket_password[0])
//           }
//          else if(response.errors.bocket_password_confirmation){
//             toast.error(response.errors.bocket_password_confirmation[0])
//           }
        
    
         
//         } catch (error) {
//           console.error(error);
        
//         }
//       };

//     useEffect(()=>{
//         fetch(`${route}/acc/getMe`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             if(data.error === "Token expired"){
//                 toast.error("قم بتسجيل الخروج و ادخل مرة اخري لاسباب أمنية")
//             }
//             else{

//                 setUser(data.user)
//             }
//         })
//         fetch(`${route}/acc/getMyTree/${sessionStorage.getItem("id")}`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             console.log(data)
//             if(data.error === "Token expired"){
//                 toast.error("قم بتسجيل الخروج و ادخل مرة اخري لاسباب أمنية")
//             }
//             else{
//                 if(data.data.leftChild){
//                     setLeft(data.data.leftChild)
//                 }
//                 if(data.data.rightChild){
//                     setRight(data.data.rightChild)
//                 }
//             }
   
//         })
//     },[])
//   return (
//  <div className="main-page">
//     <div className="container">
//    <h1 className='my-name'> مرحبا بعودتك : {sessionStorage.getItem("userName")} </h1> 
//         <div className="left">
//         <div className="customers top">
//         <h4>الفريق</h4>
//         <div className="line">
//             <div className="line-l">
//                 {left.name ? <div>{left.name}</div>:null}
//             </div>
//             <div className="line-r">
//               اليسار
//             </div>
//         </div>
//         <div className="line">
//             <div className="line-l">
//             {right.name ? <div>{right.name}</div>:null}
//             </div>
//             <div className="line-r">
//                 اليمين
//             </div>
//         </div>
//         </div>
//         {/* <div className="bank top">
// <h4>الخزنة</h4>
// <div>اٍضافة كلمة سر للخزنة</div>
// <form action="" onSubmit={handleSubmit}>
//     <input onChange={(e)=>setPass(e.target.value)} type="password" placeholder='كلمة السر الجديدة' />
//     <input onChange={(e)=>setPassConfirm(e.target.value)} type="password" placeholder='اعادة كلمة السر الجديدة' />
//     <button type='submit'>اٍضافة</button>
// </form>
//         </div> */}
//         </div>
//         <div className="right">
//     <div className="info top">
//     <h4> معلومات المكتب الخاص</h4>
//     <div className="line">
//         <div className="line-l">
//             {sessionStorage.getItem("userName")}
//         </div>
//         <div className="line-r">
//             الاٍسم
//         </div>
//     </div>
//     <div className="line">
//         <div className="line-l">
//             {sessionStorage.getItem("id")}
//         </div>
//         <div className="line-r">
//             اٍسم المستخدم
//         </div>
//     </div>
//     </div>
//     <div className="size top">
//         <h4>حجم العمل</h4>
//         <div className="in-size">
//         <div className="left-s">
//         <div>اليسار</div>
//             <div>{user.left_children}</div>
//     </div>
//         <div className="right-s">
// <div>اليمين</div>
// <div>{user.right_children}</div>
//         </div>
//         </div>
         
//         </div>
        
       
//         </div>
//     </div>
//     <Side />
//  </div>
//   )
// }

// export default MainPage
import "./main.scss";
import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../App";
import { toast } from "react-toastify";
import Side from "../side/Side";

const Skeleton = ({ height = 20 }) => (
  <div className="skeleton" style={{ height }}></div>
);

const MainPage = () => {
  const { route } = useContext(AppContext);
  const [user, setUser] = useState({});
  const [left, setLeft] = useState({});
  const [right, setRight] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch(`${route}/acc/getMe`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      }).then((r) => r.json()),
      fetch(`${route}/acc/getMyTree/${sessionStorage.getItem("id")}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      }).then((r) => r.json()),
    ]).then(([me, tree]) => {
      if (me?.error || tree?.error) {
        toast.error("انتهت الجلسة، سجل الدخول مرة أخرى");
        return;
      }
      setUser(me.user || {});
      setLeft(tree.data?.leftChild || {});
      setRight(tree.data?.rightChild || {});
      setLoading(false);
    });
  }, []);

  return (
    <div className="main-page">
      <div className="dashboard">
        <h1 className="welcome">
          مرحبًا بعودتك 👋 <span>{sessionStorage.getItem("userName")}</span>
        </h1>

        <div className="grid">
          {/* ===== Team Card ===== */}
          <div className="card">
            <h3>الفريق</h3>

            <div className="row">
              <span>اليسار</span>
              {loading ? <Skeleton /> : <strong>{left.name || "-"}</strong>}
            </div>

            <div className="row">
              <span>اليمين</span>
              {loading ? <Skeleton /> : <strong>{right.name || "-"}</strong>}
            </div>
          </div>

          {/* ===== Office Info ===== */}
          <div className="card">
            <h3>معلومات المكتب</h3>

            <div className="row">
              <span>الاسم</span>
              {loading ? <Skeleton /> : <strong>{sessionStorage.getItem("userName")}</strong>}
            </div>

            <div className="row">
              <span>الكود</span>
              {loading ? <Skeleton /> : <strong>{sessionStorage.getItem("id")}</strong>}
            </div>
          </div>

          {/* ===== Business Size ===== */}
          <div className="card">
            <h3>حجم العمل</h3>

            <div className="size-box">
              <div>
                <span>يسار</span>
                {loading ? <Skeleton height={24} /> : <strong>{user.left_children}</strong>}
              </div>
              <div>
                <span>يمين</span>
                {loading ? <Skeleton height={24} /> : <strong>{user.right_children}</strong>}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Side />
    </div>
  );
};

export default MainPage;
